import Component from '@glimmer/component'
import { Dialog } from 'teacher-ui-client/components/dialog'

interface Signature {
  Element: HTMLDialogElement
  Args: {
    onClose?: () => void
    showBackdrop?: boolean
    isFullscreen?: boolean
  }
  Blocks: {
    default: []
  }
}

export class InteractiveModal extends Component<Signature> {
  // Fullscreen mode sets the modal to full window size. In modal mode, the modal will be sized according to the content
  get sizeClasses() {
    return this.args.isFullscreen ? 'rounded-none m-0 max-w-none max-h-none w-screen h-screen' : 'rounded-lg'
  }

  <template>
    <Dialog
      @onClose={{@onClose}}
      @showBackdrop={{@showBackdrop}}
      class="overflow-hidden {{this.sizeClasses}}"
      ...attributes
    >
      {{yield}}
    </Dialog>
  </template>
}
